<template>
    <div class="">
        <div class="col s12 m12 l12 xl12">
            <div class="file-field input-field">
                <div class="btn" style="width: 100%">
                    <a  :href="'/curriculos/lattes/pdf/'+this.project.curriculo.user_id" target="_blank" >
                        <span style="font-size: 20px; color: white;">PDF do currículo</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-if="avaliacao">
            <avaliacao-curriculo-item-formacao @add-item="setItemFormacao"/>
            <avaliacao-curriculo-item-producao @avaliar-item="avaliar" />
        </div>
        
       
       
        
        
    </div>
</template>
<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import AvaliacaoCurriculoItemFormacao from './AvaliacaoCurriculoItemFormacao';
    import AvaliacaoCurriculoItemProducao from './AvaliacaoCurriculoItemProducao';
    export default {
        name: 'AvaliacaoCurriculo',
        components:{
            AvaliacaoCurriculoItemFormacao,
            AvaliacaoCurriculoItemProducao
        },
        computed:{
            ...mapState(['project']),
              avaliacao(){
                
                if(!this.project.avaliacao.avaliacao_curriculo){
                    this.$set(this.project.avaliacao,'avaliacao_curriculo',{
                        item_formacao:[],
                        item_producao:[]
                    })
                    this.setAvaliacaoCurriculo(this.project.avaliacao.avaliacao_curriculo);
                    return this.project.avaliacao.avaliacao_curriculo;
                }else{
                    try {
                        this.$set(this.project.avaliacao,'avaliacao_curriculo',
                            JSON.parse(this.project.avaliacao.avaliacao_curriculo)
                        );
                        this.setAvaliacaoCurriculo(this.project.avaliacao.avaliacao_curriculo);
                        return this.project.avaliacao.avaliacao_curriculo;
                    } catch (error) {
                        return this.project.avaliacao.avaliacao_curriculo;
                    }
                    
                }
            }
        },
        
        methods:{
            ...mapActions(['setAvaliacaoCurriculoItemProducao','setAvaliacaoCurriculo','setAvaliacaoCurriculoItemFormacao']),
            setItemFormacao(payload){
                this.$set(this.project.avaliacao.avaliacao_curriculo,'item_formacao',payload);
                this.$set(this.project.avaliacao.avaliacao_curriculo,'nota_item_formacao',payload.nota);
                this.setAvaliacaoCurriculoItemFormacao(this.project.avaliacao.avaliacao_curriculo.item_formacao);
            },
            async avaliar(payload){
                try {
                    let itensProducao = payload;
                    
                    this.$set(this.project.avaliacao.avaliacao_curriculo,'item_producao',itensProducao);
                    this.setAvaliacaoCurriculoItemProducao(this.project.avaliacao.avaliacao_curriculo.item_producao);    

                    this.$set(this.project.avaliacao.avaliacao_curriculo,'nota_item_producao',itensProducao.nota)

                    let {data}= await this.$http.post(`/api/avaliacaoCurriculo`,{
                        id:this.project.avaliacao.id,
                        avaliacao_curriculo:this.project.avaliacao.avaliacao_curriculo
                        
                        
                    });
                    showMsg(data,200);
                } catch (error) {
                    
                    showMsg(error);
                }
                

            },
          
        }
    }

</script>